import { unwrapResult } from '@reduxjs/toolkit'
import { Dropdown, Input, Row } from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  getDiseaseCompletions,
  getOnlyOrgaztionCompletions,
} from '../../features/completion/completionSlice'
import { Disease } from '../../models/disease'
import { Page, startPageOf } from '../../models/page'
import { ThemeContext } from '../../theme/ThemeContext'
import { sleep } from '../../utils/SystemUtils'
import { EditableList } from '../list/EditableList'
import styles from './DiseaseInput.module.css'

interface DiseaseInputProps {
  value?: string
  NoticeTag?: any
  disabled?: boolean
  onChange?: (value: string) => void
  placeholder?: string
  onSelect?: (disease: Disease) => void
  style?: React.CSSProperties
  click?: (isvisible?: boolean) => void
}

export const DiseaseInput = ({
  value,
  NoticeTag,
  disabled = false,
  onChange,
  placeholder,
  onSelect,
  click = () => {
    console.log(1)
  },
  style,
}: DiseaseInputProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const ref = useRef<Input>(null)

  const theme = useContext(ThemeContext)

  const [timeoutId, setTimeoutId] = useState<
    ReturnType<typeof setTimeout> | undefined
  >()

  const [page, setPage] = useState<Page<Disease>>({
    ...startPageOf(),
    size: 5,
  })

  useEffect(() => {
    return () => {
      console.log('xiaohui')
    }
  }, [])

  useEffect(() => {
    console.log(page, 'page')
  }, [])

  const [selectedId, setSelectedId] = useState('')

  const [keyword, setKeyword] = useState('')

  const [isFocused, setIsFocused] = useState(false)

  const [isVisible, setIsVisible] = useState(false)

  const load = (keyword: string, current: number, setToLast: boolean) => {
    console.log(keyword, setToLast, 'keyword')

    if (NoticeTag == true) {
      dispatch(
        getOnlyOrgaztionCompletions({
          name: keyword,
          size: page.size,
          current,
        })
      )
        .then(unwrapResult)
        .then((page) => {
          if (page.items.length > 0) {
            if (setToLast) {
              setSelectedId(page.items[page.items.length - 1].id)
            } else {
              setSelectedId(page.items[0].id)
            }
          } else {
            setSelectedId('')
          }
          if (isFocused) {
            setIsVisible(page.items.length > 0)
          }
          setPage(page)
        })
        .catch(() => {
          //
        })
    } else {
      dispatch(
        getDiseaseCompletions({
          param: keyword,
          size: page.size,
          current,
        })
      )
        .then(unwrapResult)
        .then((page) => {
          if (page.items.length > 0) {
            if (setToLast) {
              setSelectedId(page.items[page.items.length - 1].id)
            } else {
              setSelectedId(page.items[0].id)
            }
          } else {
            setSelectedId('')
          }
          if (isFocused) {
            setIsVisible(page.items.length > 0)
          }
          setPage(page)
        })
        .catch(() => {
          //
        })
    }
  }

  const select = (disease?: Disease) => {
    if (disease) {
      onSelect && onSelect(disease)
    }
    onChange && onChange('')
    setKeyword('')
    setIsVisible(false)
  }

  console.log(isVisible, page.items, 'disableddisabled')

  const overlay = (
    <Row
      style={{ width: 656 }}
      onClick={async () => {
        if (timeoutId) {
          clearTimeout(timeoutId)
          setTimeoutId(undefined)
        }
        await sleep(300)
        ref.current?.focus()
      }}
    >
      <EditableList<Disease>
        className={styles.table}
        showQuickJumper={false}
        showSizeChanger={false}
        rowClassName={(d) => (d.id === selectedId ? styles.selected : '')}
        page={page}
        bordered
        onRow={(d) => ({
          onClick: (e) => {
            e.stopPropagation()
            select(d)
          },
        })}
        columns={[
          {
            title: <div style={{ paddingLeft: 8 }}>机构名称</div>,
            key: 'name',
            align: 'left',
            ellipsis: true,
            render: (_, d) => ({
              props: {
                style: {
                  color: theme.tc1,

                  fontSize: '1.125rem',
                  fontWeight: 'bold',
                },
              },
              children: <div style={{ padding: '0 8px' }}>{d.name}</div>,
            }),
          },
          // {
          //   title: '疾病代码',
          //   align: 'center',
          //   dataIndex: 'icds',
          //   ellipsis: true,
          //   width: '10rem',
          // },
          // {
          //   title: '疾病类型',
          //   align: 'center',
          //   key: 'category',
          //   width: '6rem',
          //   render: (_, d) =>
          //     d.category === 2 ? '慢病' : d.category === 1 ? '特病' : '普病',
          // },
        ]}
        onChangePage={(current) => load(keyword, current, false)}
      />
    </Row>
  )

  return (
    <Dropdown
      overlay={overlay}
      disabled={disabled}
      align={{
        overflow: {
          adjustX: false,
          adjustY: false,
        },
      }}
      visible={isVisible && page.items.length > 0}
      getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
      onVisibleChange={(v) => setIsVisible(v)}
    >
      <Input
        ref={ref}
        disabled={disabled}
        placeholder={placeholder}
        style={style}
        value={value}
        onFocus={() => {
          setIsFocused(true)
          setIsVisible(true)
          click()
        }}
        onBlur={() => {
          if (timeoutId) {
            return
          }
          const id = setTimeout(() => {
            setIsFocused(false)
            setIsVisible(false)
            setTimeoutId(undefined)
          }, 300)
          setTimeoutId(id)
        }}
        onChange={(e) => {
          setIsVisible(true)
          load(e.target.value, 1, false)
          setKeyword(e.target.value)
          onChange && onChange(e.target.value)
        }}
        onPressEnter={() => {
          const disease = page.items.find((d) => d.id === selectedId)
          select(disease)
        }}
        onKeyDown={(e) => {
          switch (e.key) {
            case 'ArrowDown':
              {
                const index = page.items.findIndex((d) => d.id === selectedId)
                if (index < 0) {
                  return
                }
                if (index + 1 < page.items.length) {
                  setSelectedId(page.items[index + 1].id)
                } else {
                  if (page.total >= page.size * page.current) {
                    load(keyword, page.current + 1, false)
                  }
                }
              }
              break
            case 'ArrowUp':
              {
                const index = page.items.findIndex((d) => d.id === selectedId)
                if (index < 0) {
                  return
                }
                if (index - 1 >= 0) {
                  setSelectedId(page.items[index - 1].id)
                } else {
                  if (page.current > 1) {
                    load(keyword, page.current - 1, true)
                  }
                }
              }
              break
            case 'ArrowRight':
              if (page.current * page.size < page.total) {
                load(keyword, page.current + 1, false)
              }
              break
            case 'ArrowLeft':
              if (page.current > 1) {
                load(keyword, page.current - 1, false)
              }
              break
            case 'Escape':
              setIsVisible(false)
              break
          }
        }}
      />
    </Dropdown>
  )
}
